import Message from '@sats-group/ui-lib/react/message';
import React, { useState } from 'react';
import { type MessageHandler, useMessage } from '~/source/client/use-message';
import type { Messages as Props } from './messages.types';

type MessageProps = Parameters<typeof Message>[0];

type Entry = {
  key: string;
  props: MessageProps;
};

export const Messages: React.FC<Props> = ({ close }) => {
  const [messages, setMessages] = useState<Entry[]>([]);

  const removeMessage = (key: string) => () =>
    setMessages(prev => prev.filter(entry => entry.key !== key));

  const addMessage: MessageHandler = props =>
    setMessages(prev => {
      const key = window.crypto.randomUUID();
      const action = {
        elementName: 'button',
        onClick: removeMessage(key),
        text: close,
        type: 'button',
      } satisfies MessageProps['action'];
      const newProps = Object.assign({}, props, { action });

      return prev.concat({ key, props: newProps });
    });

  useMessage(addMessage);

  return (
    <aside aria-live="polite" className="messages">
      {messages.map(entry => (
        <Message {...entry.props} key={entry.key} />
      ))}
    </aside>
  );
};
